import React from 'react';
import Reveal from '../ui/Reveal';
import SpotCard from './SpotCard';
import InfinityPathAnimation from './InfinityPathAnimation';
import { methodPillars } from '../../data/masterclass';

const MethodSection: React.FC = () => {
  return (
    <section id="metodo" className="relative scroll-mt-36 py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="max-w-3xl">
          <div className="mb-4 flex items-center gap-3">
            <span className="text-sm text-white/30">01</span>
            <span className="eyebrow-mc text-mc-electric/90">El Método WITS</span>
          </div>
          <h2 className="font-display text-3xl font-bold leading-[1.1] md:text-5xl">
            No se trata solo de usar IA. Se trata de{' '}
            <span className="text-gradient-mc">aprender a trabajar con ella.</span>
          </h2>
          <p className="mt-6 font-light leading-relaxed text-white/65">
            Muchas personas ya usan ChatGPT, pero siguen haciendo las mismas tareas de antes. El problema no es
            aprender más herramientas: es saber <span className="font-medium text-white">dónde, cómo y para qué</span>{' '}
            aplicar IA. El Método WITS es un recorrido continuo — como el infinito de nuestra marca.
          </p>
        </Reveal>

        <Reveal delay={80} className="mt-14">
          <InfinityPathAnimation />
        </Reveal>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {methodPillars.map((pillar, index) => (
            <Reveal key={pillar.letter} delay={index * 80}>
              <SpotCard className="h-full rounded-[22px] border border-white/10 bg-white/5 p-7 backdrop-blur-md">
                <div className="flex items-center justify-between">
                  <div className="font-display text-5xl font-extrabold leading-none text-gradient-mc">
                    {pillar.letter}
                  </div>
                  <span className="text-xs text-white/25">{pillar.tag}</span>
                </div>
                <h3 className="mt-5 font-display text-lg font-bold">{pillar.title}</h3>
                <p className="mt-2 text-sm font-light leading-relaxed text-white/60">{pillar.description}</p>
              </SpotCard>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MethodSection;
